
















































































































































































































































































































































import { mapActions } from 'vuex';
import Vue from 'vue';

enum STEP {
  NOTIFICATION = 1,
  SCHDEULE = 2,
  SEND = 3
}
enum STATE {
  INITIAL,
  EXPANDED
}
import { truncate } from 'lodash';
import moment from 'moment-timezone';

export default Vue.extend({
  name: 'notification-form',
  components: {},

  data() {
    return {
      valid: true,
      use_scheduled_time: false,
      timezone: moment.tz.guess() ?? '',
      value: STEP.NOTIFICATION,
      notification: {
        title: '',
        message: '',
        scheduled_time: new Date() as Date | string,
        imageUrl: null as File | null
      },
      response: null,
      notificationState: STATE.INITIAL,
      STEP,
      STATE,
      defaults: {
        scheduled_time: 'Now',
        androidImage:
          'https://www.gstatic.com/mobilesdk/190403_mobilesdk/android.png',
        iosImage:
          'https://www.gstatic.com/mobilesdk/190403_mobilesdk/iphone.png',
        image:
          'https://www.gstatic.com/mobilesdk/180130_mobilesdk/images/image_placeholder.png'
      },
      cacheImage: null as any | null | File,
      imageRules: [
        (value: File) =>
          !value ||
          value.size < 2000000 ||
          'Image size should be less than 2 MB!'
      ],
      textRules: [
        (v: any) => !!v || 'Field is required',
        (v: any) =>
          (v && v.length <= 256) || 'Field must be less than 256 characters'
      ]
    };
  },
  methods: {
    truncate,
    ...mapActions('notifications', ['createNotification']),
    ...mapActions('social', ['sendTweet']),
    async sendMessage(notification: {
      title: string;
      message: string;
      event: string;
      scheduled_time: Date;
    }) {
      if ((this.$refs.form as any).validate()) {
        if (this.use_scheduled_time) {
          const scheduledTimewithTimeZone = moment
            .tz(notification.scheduled_time, this.timezone)
            .utc();
          notification.scheduled_time = scheduledTimewithTimeZone.toDate();
        }

        await this.createNotification({
          title: notification.title,
          message: notification.message,
          event: localStorage.getItem('current__event'),
          data: null,
          scheduled_time: this.use_scheduled_time
            ? notification.scheduled_time
            : null
        }).then(async () => {
          this.reset();
          this.value = STEP.NOTIFICATION;
        });
      } else {
        const errors = 'Validated failed';
        console.log({ errors });
      }
    },
    updateImage(val: any) {
      console.log('updated image');
      console.log(val);

      if (val) {
        try {
          const reader = new FileReader();
          reader.onload = (e: ProgressEvent<FileReader>) => {
            this.cacheImage = e.target?.result;
          };
          reader.readAsDataURL(val);
        } catch (e) {
          this.cacheImage = null;
          console.log(e);
        }
      }
    },

    reset() {
      (this.$refs.form as any).reset();
      (this.$refs.form as any).resetValidation();
    }
  }
});
